<template>
  <button
    class="tooth-popup"
    type="button"
    v-bind:class="{ flip, selected }"
    v-on:click="toggle">
    <svg
      class="tooth-popup__parts"
      width="26"
      height="51"
      viewBox="0 0 26 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M9.12131 25.5461C9.12131 27.3174 8.05277 32.9929 7.91748 35.6549L18.5079 36.6152C18.4258 32.1842 18.1455 21.6138 17.6812 14.7803C17.217 7.94673 12.2619 4.16111 10.9319 2.86382C10.7143 2.59425 10.1195 2.31794 9.4811 3.36926C6.10114 8.93565 9.91407 16.434 9.29888 22.9171C9.20061 23.9527 9.12131 24.8634 9.12131 25.5461Z" />
      <path d="M18.4065 49.2522L8.81793 49.3003C8.48856 49.3019 8.1595 49.2799 7.83329 49.2345C7.67642 49.2126 7.52007 49.1845 7.37574 49.1192C7.18198 49.0317 6.88985 48.8625 6.6167 48.5583C6.00095 47.8724 5.98854 46.8674 6.02193 45.9462C6.0973 43.867 6.38527 40.5711 7.16255 37.5765C7.35078 36.8514 7.61065 36.214 7.91737 35.6559C9.02595 33.6386 10.7466 32.6556 11.9093 32.2993C12.269 32.1891 12.6471 32.1683 13.0233 32.1683C13.7543 32.1683 14.4912 32.2649 15.1376 32.6062C16.1497 33.1406 17.4167 34.0847 18.0438 35.4537C18.2017 35.7985 18.3573 36.1929 18.5078 36.6162C18.5403 36.7075 18.572 36.8003 18.6031 36.8943C19.7529 40.3788 20.2127 44.1232 20.0024 47.7864C19.9723 48.3106 19.7979 48.6672 19.5964 48.8985C19.3114 49.2255 18.8403 49.2522 18.4065 49.2522Z" />
    </svg>
    <div class="tooth-popup__number">{{number}}</div>
  </button>
</template>

<script>
import popupTeethMixin from '@/mixins/popupTeethMixin';

export default {
  mixins: [popupTeethMixin],
  name: 'ToothUp2',
};
</script>

<style>
</style>
